(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isun-collection-text"] && !Shopify.designMode) return;
  try {
    
  customElements.define('isun-collection-text', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('toggle', (event) => {
        if (event.target.matches('.isun-collection-text__details') && event.target.open) {
          this.querySelector('.isun-collection-text__remainder').focus({ preventScroll: true });
        }
      }, true);
      this.addEventListener('click', (event) => {
        if (!event.target.closest('.isun-collection-text__close')) return;
        const details = this.querySelector('details');
        const summary = details.querySelector('summary');
        details.open = false;
        summary.focus({ preventScroll: true });
        summary.scrollIntoView({ block: 'center' });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isun-native-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.isun-native-reviews img.jdgm-carousel-item__product-image';

    const showImageLabel = (image) => {
      if (!image.matches(selector) || image.dataset.isunImageFallback) return;
      image.dataset.isunImageFallback = 'true';
      const label = document.createElement('span');
      label.className = 'isun-native-reviews__image-label';
      label.textContent = image.alt;
      image.hidden = true;
      image.style.display = 'none';
      image.insertAdjacentElement('afterend', label);
    };

    document.addEventListener('error', (event) => {
      if (event.target instanceof HTMLImageElement) showImageLabel(event.target);
    }, true);

    const inspectLoadedImages = (root) => {
      root.querySelectorAll(selector).forEach((image) => {
        if (image.getAttribute('src') && image.complete && image.naturalWidth === 0) {
          showImageLabel(image);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => inspectLoadedImages(document), { once: true });
    } else {
      inspectLoadedImages(document);
    }

    document.addEventListener('shopify:section:load', (event) => inspectLoadedImages(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isun-ritual-builder"] && !Shopify.designMode) return;
  try {
    
  const ritualProductData = new Map();

  const fetchRitualProductData = (handle) => {
    if (!ritualProductData.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      const url = `${root}products/${encodeURIComponent(handle)}?view=ritual-data`;
      ritualProductData.set(handle, fetch(url, { credentials: 'same-origin' })
        .then((response) => response.ok ? response.json() : null)
        .catch(() => null));
    }
    return ritualProductData.get(handle);
  };

  const conciseCardDescription = (data) => {
    const source = data?.description || '';
    const clean = source.replace(/<[^>]*>/g, ' ').replace(/^[\s•*\-–—]+/, '').replace(/\s+/g, ' ').trim();
    if (!clean) return '';
    const sentence = clean.match(/^.*?[.!?](?:\s|$)/)?.[0] || clean;
    return sentence.length > 155 ? `${sentence.slice(0, 152).trim()}…` : sentence;
  };

  const fixedRitualItemSelector = (ritual) => `.bogos-bundle-pp-item[data-product-id="${ritual.dataset.fixedProductId}"]`;

  // Use the app's option handler: it owns variant ID, price, availability,
  // quantity preservation, totals and the eventual _bogos_bundle_config.
  const selectFixedRitualVariant = (ritual, container, state, optionSelector, priceKey, availableKey) => {
    const variantId = ritual.dataset.fixedVariantId;
    const option = container.querySelector(`${optionSelector}[data-variant-id="${variantId}"]`);
    const expectedPrice = Number(option?.dataset[priceKey]);
    const available = option?.dataset[availableKey] === '1';
    const matches = () => state.dataset.variantId === variantId && available &&
      (availableKey !== 'available' || state.dataset.available === '1') &&
      Number.isFinite(expectedPrice) && Number(state.dataset.price) === expectedPrice;
    if (!matches() && option && available) option.click();
    const ready = matches();
    const readyValue = String(ready);
    if (container.dataset.isunFixedVariantReady !== readyValue) container.dataset.isunFixedVariantReady = readyValue;
    if (ready) {
      container.querySelectorAll(optionSelector).forEach((choice) => {
        if (choice.dataset.variantId !== variantId) choice.remove();
      });
    }
    return ready;
  };

  const ensureFixedRitualVariant = (ritual) => {
    if (!ritual.dataset.fixedProductId || !ritual.dataset.fixedVariantId) return true;
    const items = [...ritual.querySelectorAll(fixedRitualItemSelector(ritual))];
    const ready = items.length > 0 && items.map((item) => selectFixedRitualVariant(
      ritual, item, item, '.bogos-bundle-pp-select-variant-option', 'price', 'available'
    )).every(Boolean);
    const status = ritual.querySelector('[data-fixed-variant-unavailable]');
    const hideStatus = ready || !items.length;
    if (status && status.hidden !== hideStatus) status.hidden = hideStatus;
    return ready;
  };

  const ensureFixedRitualModal = (ritual) => {
    const modal = document.querySelector('#bogos-main-popup-product-detail-container .bogos-product-detail-modal');
    const button = modal?.querySelector('.bogos-product-add-btn');
    if (!button || button.dataset.productId !== ritual.dataset.fixedProductId) return true;
    return selectFixedRitualVariant(ritual, modal, button, '.bogos-variant-item', 'variantPrice', 'checkVariantAvailable');
  };

  const guardFixedRitualVariant = (ritual, event) => {
    if (!ritual.dataset.fixedProductId) return;
    const item = event.target.closest(fixedRitualItemSelector(ritual));
    const choice = event.target.closest('.bogos-bundle-pp-select-variant-option');
    const unsupportedChoice = event.target.closest('.bogos-select-option-custom-item');
    if (item && ((choice && choice.dataset.variantId !== ritual.dataset.fixedVariantId) || unsupportedChoice)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const guardedAction = event.target.closest('.bogos-bundle-pp-btn-add') ||
      (item && event.target.closest('.bogos-bundle-pp-add-btn, .bogos-bundle-pp-plus, .bogos-bundle-pp-item-name'));
    if (guardedAction && !ensureFixedRitualVariant(ritual)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const status = ritual.querySelector('.bogos-bn-status');
      if (status) status.textContent = ritual.dataset.unavailable;
    }
  };

  const selectedRitualItemCount = (ritual) => [...ritual.querySelectorAll('.bogos-bundle-pp-item[data-qty]')]
    .reduce((total, item) => total + (Number.parseInt(item.dataset.qty, 10) || 0), 0);

  const completeRitualCartAdd = (ritual) => {
    const pending = ritual.ritualCartPending;
    if (!pending) return;
    ritual.ritualCartPending = null;
    window.clearTimeout(pending.timeout);
    pending.button.removeAttribute('aria-busy');
    if (pending.externalButton) {
      pending.externalButton.disabled = false;
      pending.externalButton.removeAttribute('aria-busy');
    }
    if (pending.status) pending.status.textContent = '';
    const drawer = document.querySelector('.js-cart-drawer');
    const openDrawer = () => {
      if (typeof drawer?.open === 'function') {
        drawer.open(pending.button);
      } else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
          bubbles: true,
          cancelable: false,
          detail: { opener: pending.button }
        }));
      }
    };
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
    openDrawer();
  };

  const monitorRitualCartAdd = (ritual) => {
    const pending = ritual.ritualCartPending;
    if (!pending) return;
    const addConfirmed = [...ritual.querySelectorAll('.bogos-bn-status')]
      .some((status) => ['added to cart', ritual.dataset.addedToCart.toLowerCase()].includes(status.textContent.trim().toLowerCase()));
    if (pending.selectedCount > 0 && selectedRitualItemCount(ritual) === 0 && addConfirmed) {
      completeRitualCartAdd(ritual);
    }
  };

  const resetCompleteRitualButton = (button, status, message = '') => {
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
    if (status) status.textContent = message;
  };

  const availableBogosItems = (step) => [...step.querySelectorAll('.bogos-bundle-pp-item[data-qty]')]
    .filter((item) => item.dataset.isunFixedVariantReady !== 'false' && item.dataset.available !== '0' && !item.hidden && getComputedStyle(item).display !== 'none');

  const preselectRitualProducts = (ritual) => {
    if (!ensureFixedRitualVariant(ritual) || ritual.ritualInitialSelectionComplete || ritual.ritualCustomerCustomized) return;
    const steps = [...ritual.querySelectorAll('.bogos-bundle-pp-step')];
    if (!steps.length || steps.some((step) => !step.querySelector('.bogos-bundle-pp-item[data-qty]'))) return;
    const available = steps.flatMap(availableBogosItems);
    if (!available.length) return;
    ritual.ritualIsAutoSelecting = true;
    available.forEach((item) => {
      if ((Number.parseInt(item.dataset.qty, 10) || 0) > 0) return;
      const selectButton = item.querySelector('.bogos-bundle-pp-add-btn');
      if (selectButton && !selectButton.disabled) selectButton.click();
    });
    ritual.ritualIsAutoSelecting = false;
    ritual.ritualInitialSelectionComplete = true;
  };

  const completeRitualChoice = (step) => {
    const available = availableBogosItems(step);
    const selected = available.filter((item) => (Number.parseInt(item.dataset.qty, 10) || 0) > 0);
    if (selected.length === 1) return selected[0];
    if (selected.length > 1) return null;
    const explicit = available.filter((item) => item.matches('.is-active, .active, .selected, [aria-selected="true"], [aria-pressed="true"], [data-selected="true"]'));
    if (explicit.length === 1) return explicit[0];
    return available.length === 1 ? available[0] : null;
  };

  const waitForCompleteRitualSelection = (ritual, choices, button, status) => {
    const startedAt = Date.now();
    const check = () => {
      const ready = ensureFixedRitualVariant(ritual) && choices.every((item) => (Number.parseInt(item.dataset.qty, 10) || 0) > 0);
      const cartButton = ritual.querySelector('.bogos-bundle-pp-btn-add');
      if (ready && cartButton && !cartButton.disabled && cartButton.getAttribute('aria-disabled') !== 'true') {
        ritual.ritualExternalTrigger = { button, status };
        cartButton.click();
        const submittedAt = Date.now();
        const confirm = () => {
          const added = [...ritual.querySelectorAll('.bogos-bn-status')]
            .some((message) => ['added to cart', ritual.dataset.addedToCart.toLowerCase()].includes(message.textContent.trim().toLowerCase()));
          if (added && selectedRitualItemCount(ritual) === 0) {
            resetCompleteRitualButton(button, status);
            ritual.ritualExternalTrigger = null;
            return;
          }
          if (Date.now() - submittedAt > 15000) {
            resetCompleteRitualButton(button, status, ritual.dataset.notAdded);
            ritual.ritualExternalTrigger = null;
            return;
          }
          requestAnimationFrame(confirm);
        };
        confirm();
        return;
      }
      if (Date.now() - startedAt > 8000) {
        resetCompleteRitualButton(button, status, ritual.dataset.selectionFailed);
        return;
      }
      requestAnimationFrame(check);
    };
    check();
  };

  document.addEventListener('isun:ritual:buy-complete', (event) => {
    const ritual = document.querySelector('.isun-ritual');
    const button = event.detail?.button;
    const status = event.detail?.status;
    if (!ritual || ritual.ritualCartPending) {
      resetCompleteRitualButton(button, status, (ritual || document.querySelector('[data-isun-ritual-steps-section]'))?.dataset.builderNotReady || '');
      return;
    }
    if (!ensureFixedRitualVariant(ritual)) {
      resetCompleteRitualButton(button, status, ritual.dataset.unavailable);
      return;
    }
    const steps = [...ritual.querySelectorAll('.bogos-bundle-pp-step')];
    const purchasableSteps = steps.filter((step) => availableBogosItems(step).length > 0);
    const choices = purchasableSteps.map(completeRitualChoice);
    if (!purchasableSteps.length) {
      resetCompleteRitualButton(button, status, ritual.dataset.unavailable);
      return;
    }
    if (choices.some((choice) => !choice)) {
      resetCompleteRitualButton(button, status, ritual.dataset.chooseOptions);
      return;
    }
    choices.forEach((item) => {
      if ((Number.parseInt(item.dataset.qty, 10) || 0) > 0) return;
      const selectButton = item.querySelector('.bogos-bundle-pp-add-btn');
      if (selectButton && !selectButton.disabled) selectButton.click();
    });
    waitForCompleteRitualSelection(ritual, choices, button, status);
  });

  const updateWeightedReviews = async (ritual) => {
    const handles = [...new Set([...ritual.querySelectorAll('.bogos-bundle-pp-item[data-product-handle]')]
      .map((item) => item.dataset.productHandle)
      .filter(Boolean))];
    if (!handles.length) return;
    const data = (await Promise.all(handles.map(fetchRitualProductData))).filter(Boolean);
    const reviewed = data.filter((item) => Number(item.reviewCount) > 0 && Number(item.rating) > 0);
    const reviewCount = reviewed.reduce((sum, item) => sum + Number(item.reviewCount), 0);
    if (!reviewCount) return;
    const rating = reviewed.reduce((sum, item) => sum + (Number(item.rating) * Number(item.reviewCount)), 0) / reviewCount;
    const output = ritual.querySelector('[data-isun-weighted-reviews]');
    if (!output) return;
    output.querySelector('[data-isun-review-stars]').style.width = `${(rating / 5) * 100}%`;
    output.querySelector('[data-isun-review-label]').textContent = `${rating.toFixed(1)} · ${reviewCount} ${ritual.dataset.reviewLabel}`;
    output.setAttribute('aria-label', ritual.dataset.weightedReviewsLabel.replace('__rating__', rating.toFixed(1)).replace('__count__', String(reviewCount)).replace('__reviews__', ritual.dataset.reviewLabel));
    output.hidden = false;
    ritual.classList.add('has-weighted-reviews');
  };

  const updateRitualLabels = (ritual) => {
    const currency = window.Shopify?.currency?.active || ritual.dataset.currencyCode;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2
    });
    ritual.querySelectorAll('.bogos-bundle-pp-item[data-price]').forEach((item) => {
      const amount = Number(item.dataset.price);
      if (!Number.isFinite(amount)) return;
      const formatted = formatter.format(amount);
      if (item.dataset.formattedPrice !== formatted) item.dataset.formattedPrice = formatted;
    });
    const totalLabel = ritual.querySelector('.bogos-bundle-pp-total-label');
    if (totalLabel && totalLabel.textContent !== ritual.dataset.totalPriceLabel) {
      totalLabel.textContent = ritual.dataset.totalPriceLabel;
    }
    const basketButton = ritual.querySelector('.bogos-bundle-pp-btn-add');
    if (basketButton && !basketButton.classList.contains('bogos-bundles-adding') && basketButton.getAttribute('aria-busy') !== 'true') {
      if (basketButton.textContent !== ritual.dataset.addToBasketLabel) basketButton.textContent = ritual.dataset.addToBasketLabel;
    }
  };

  const arrangeRitualProducts = (ritual) => {
    const stepTitles = [...ritual.querySelectorAll('.bogos-bundle-pp-step-title')]
      .map((title) => title.textContent.trim())
      .filter(Boolean);
    const stepSummary = ritual.querySelector('[data-isun-ritual-steps]');
    if (stepSummary && stepTitles.length) {
      stepSummary.textContent = stepTitles.join(' • ');
      stepSummary.hidden = false;
    }

    ritual.querySelectorAll('.bogos-bundle-pp-item-info').forEach((info) => {
      const name = info.querySelector('.bogos-bundle-pp-item-name');
      const variant = info.querySelector('.bogos-bundle-pp-select-variant-wrapper');
      let line = info.querySelector(':scope > .isun-ritual__product-line');
      if (!line && name && variant) {
        name.title = name.textContent.trim();
        line = document.createElement('div');
        line.className = 'isun-ritual__product-line';
        info.insertBefore(line, name);
        line.append(name, variant);
      }
      if (!line) return;

      const step = info.closest('.bogos-bundle-pp-step');
      const rawStepTitle = step?.querySelector('.bogos-bundle-pp-step-title')?.textContent.trim();
      let cardStep = line.querySelector('.isun-ritual__card-step');
      if (rawStepTitle && !cardStep) {
        const steps = [...step.parentElement.children].filter((child) => child.classList.contains('bogos-bundle-pp-step'));
        cardStep = document.createElement('div');
        cardStep.className = 'isun-ritual__card-step';
        cardStep.textContent = `${steps.indexOf(step) + 1}. ${rawStepTitle}`;
        line.prepend(cardStep);
      }

      const productName = line.querySelector('.bogos-bundle-pp-item-name');
      let titleRow = productName?.querySelector('.isun-ritual__product-title-row');
      if (productName && !titleRow) {
        const title = productName.textContent.trim();
        productName.textContent = '';
        titleRow = document.createElement('span');
        titleRow.className = 'isun-ritual__product-title-row';
        const titleText = document.createElement('span');
        titleText.className = 'isun-ritual__product-title-text';
        titleText.textContent = title;
        titleRow.append(titleText);
        productName.append(titleRow);
      }

      const lineVariant = line.querySelector('.bogos-bundle-pp-select-variant-wrapper');
      const selected = lineVariant?.querySelector('.bogos-bundle-pp-select-variant-title')?.textContent.trim();
      const optionCount = lineVariant?.querySelectorAll('.bogos-bundle-pp-select-variant-option').length || 0;
      let inlineVariant = titleRow?.querySelector('.isun-ritual__variant-inline');
      const meaningfulVariant = selected && selected.toLowerCase() !== 'default title';
      if (meaningfulVariant && titleRow) {
        if (!inlineVariant) {
          inlineVariant = document.createElement('span');
          inlineVariant.className = 'isun-ritual__variant-inline';
          titleRow.append(inlineVariant);
        }
        inlineVariant.textContent = `(${selected})`;
      } else {
        inlineVariant?.remove();
      }
      lineVariant?.classList.toggle('is-single-variant', optionCount <= 1);

      const item = info.closest('.bogos-bundle-pp-item');
      const handle = item?.dataset.productHandle;
      if (handle && productName && !productName.querySelector('.isun-ritual__card-description')) {
        fetchRitualProductData(handle).then((data) => {
          const description = conciseCardDescription(data);
          if (!description || productName.querySelector('.isun-ritual__card-description')) return;
          const detail = document.createElement('span');
          detail.className = 'isun-ritual__card-description';
          detail.textContent = description;
          productName.append(detail);
        });
      }
    });
    updateWeightedReviews(ritual);
  };

  document.querySelectorAll('.isun-ritual').forEach((ritual) => {
    let scheduled = false;
    const refresh = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        preselectRitualProducts(ritual);
        arrangeRitualProducts(ritual);
        updateRitualLabels(ritual);
        monitorRitualCartAdd(ritual);
      });
    };
    ritual.addEventListener('click', (event) => {
      if (!ritual.ritualIsAutoSelecting && event.target.closest('.bogos-bundle-pp-add-btn, .bogos-bundle-pp-minus')) {
        ritual.ritualCustomerCustomized = true;
      }
    });
    ritual.addEventListener('click', (event) => guardFixedRitualVariant(ritual, event), true);
    if (ritual.dataset.fixedProductId) {
      document.addEventListener('click', (event) => {
        const modal = event.target.closest('.bogos-product-detail-modal');
        const button = modal?.querySelector('.bogos-product-add-btn');
        if (!button || button.dataset.productId !== ritual.dataset.fixedProductId) return;
        const choice = event.target.closest('.bogos-variant-item');
        const unsupportedChoice = event.target.closest('.bogos-select-option-custom-item');
        if ((choice && choice.dataset.variantId !== ritual.dataset.fixedVariantId) || unsupportedChoice ||
            (event.target.closest('.bogos-product-add-btn') && !ensureFixedRitualModal(ritual))) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      const watchModal = () => {
        const root = document.querySelector('#bogos-main-popup-product-detail-container');
        if (!root) return false;
        new MutationObserver(() => ensureFixedRitualModal(ritual)).observe(root, {
          childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-id', 'data-price']
        });
        ensureFixedRitualModal(ritual);
        return true;
      };
      if (!watchModal()) {
        const waitForModal = new MutationObserver(() => { if (watchModal()) waitForModal.disconnect(); });
        waitForModal.observe(document.body, { childList: true, subtree: true });
      }
      window.addEventListener('pageshow', refresh);
    }
    refresh();
    const observer = new MutationObserver(refresh);
    const apps = ritual.querySelector('.isun-ritual__apps');
    if (apps) observer.observe(apps, { attributes: true, childList: true, characterData: true, subtree: true });
  });

  document.addEventListener('click', (event) => {
    const reviewTrigger = event.target.closest('[data-isun-ritual-reviews-trigger]');
    if (reviewTrigger) {
      const reviews = document.querySelector('[data-isun-ritual-reviews-section]');
      if (reviews && !reviews.hidden) {
        reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const heading = reviews.querySelector('[data-isun-ritual-reviews-heading]');
        window.setTimeout(() => heading?.focus({ preventScroll: true }), 500);
      }
      return;
    }

    const cartButton = event.target.closest('.isun-ritual .bogos-bundle-pp-btn-add');
    if (cartButton && !cartButton.disabled && cartButton.getAttribute('aria-disabled') !== 'true') {
      const ritual = cartButton.closest('.isun-ritual');
      const selectedCount = selectedRitualItemCount(ritual);
      if (selectedCount > 0) {
        if (ritual.ritualCartPending) window.clearTimeout(ritual.ritualCartPending.timeout);
        cartButton.setAttribute('aria-busy', 'true');
        const timeout = window.setTimeout(() => {
          if (!ritual.ritualCartPending) return;
          const pending = ritual.ritualCartPending;
          ritual.ritualCartPending = null;
          cartButton.removeAttribute('aria-busy');
          resetCompleteRitualButton(pending.externalButton, pending.status, ritual.dataset.notAdded);
        }, 15000);
        const externalTrigger = ritual.ritualExternalTrigger;
        ritual.ritualExternalTrigger = null;
        ritual.ritualCartPending = {
          button: cartButton,
          selectedCount,
          timeout,
          externalButton: externalTrigger?.button,
          status: externalTrigger?.status
        };
      }
      return;
    }

    const button = event.target.closest('[data-isun-gallery-button]');
    if (!button) return;
    const gallery = button.closest('.isun-ritual__visual');
    if (!gallery) return;
    const selectedIndex = button.dataset.isunGalleryButton;
    gallery.querySelectorAll('[data-isun-gallery-media]').forEach((media) => {
      const isActive = media.dataset.isunGalleryMedia === selectedIndex;
      media.hidden = !isActive;
      media.classList.toggle('is-active', isActive);
    });
    gallery.querySelectorAll('[data-isun-gallery-button]').forEach((item) => {
      const isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', String(isActive));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isun-ritual-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-isun-ritual-reviews-section]');
    const ritual = document.querySelector('.isun-ritual');
    if (!section || !ritual) return;

    const tabs = section.querySelector('[data-isun-review-tabs]');
    const productLabel = section.querySelector('[data-isun-review-product]');
    const widgetHost = section.querySelector('[data-isun-review-widget]');
    const products = new Map();
    const pendingHandles = new Set();
    let activeId = '';
    let refreshQueued = false;

    const productUrl = (handle) => {
      const root = window.Shopify?.routes?.root || '/';
      return `${root}products/${encodeURIComponent(handle)}?view=ritual-data`;
    };

    const normalizeReviewData = (product) => {
      let data = product.reviewWidgetData;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (_) { data = null; }
      }
      if (!data || !Array.isArray(data.reviews)) {
        const source = document.createElement('template');
        source.innerHTML = typeof product.reviewWidgetHtml === 'string' ? product.reviewWidgetHtml : '';
        const widget = source.content.querySelector('.jdgm-rev-widg');
        if (!widget) return { ...product, reviewWidgetData: null };
        const reviews = [...widget.querySelectorAll('.jdgm-rev-widg__reviews > .jdgm-rev')].slice(0, 5).map((review) => {
          const body = review.querySelector('.jdgm-rev__body');
          const paragraphs = body ? [...body.querySelectorAll('p')] : [];
          const text = (node) => {
            const copy = node.cloneNode(true);
            copy.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
            return copy.textContent.trim();
          };
          return {
            id: review.dataset.reviewId,
            rating: Number(review.querySelector('.jdgm-rev__rating')?.dataset.score),
            reviewer_name: review.querySelector('.jdgm-rev__author')?.textContent.trim() || '',
            title: review.querySelector('.jdgm-rev__title')?.textContent.trim() || '',
            body: paragraphs.length ? paragraphs.map(text).join('\n\n') : (body ? text(body) : ''),
            created_at: review.querySelector('.jdgm-rev__timestamp')?.getAttribute('datetime') || '',
            verified_buyer: review.dataset.verifiedBuyer === 'true',
            product_title: product.title
          };
        }).filter((review) => review.id && Number.isInteger(review.rating) && review.rating >= 1 && review.rating <= 5);
        data = {
          number_of_reviews: Number(widget.dataset.numberOfReviews),
          average_rating: Number(widget.dataset.averageRating),
          reviews
        };
      }
      return { ...product, reviewCount: Number(data.number_of_reviews), reviewWidgetData: data };
    };

    const mountWidget = (product) => {
      activeId = String(product.id);
      tabs.querySelectorAll('[role="tab"]').forEach((tab) => {
        const active = tab.dataset.productId === activeId;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active) widgetHost.setAttribute('aria-labelledby', tab.id);
      });
      productLabel.textContent = `${section.dataset.productLabel}: ${product.title}`;
      widgetHost.replaceChildren();
      const data = product.reviewWidgetData;
      const summary = document.createElement('div');
      summary.className = 'isun-ritual-reviews__summary';
      const average = document.createElement('strong');
      average.textContent = `${Number(data.average_rating).toFixed(1)} ★`;
      const count = document.createElement('span');
      count.textContent = (Number(data.number_of_reviews) === 1 ? section.dataset.reviewsSingular : section.dataset.reviewsPlural).replace('__count__', String(data.number_of_reviews));
      summary.append(average, count);
      widgetHost.append(summary);

      const list = document.createElement('div');
      list.className = 'isun-ritual-reviews__list';
      const visibleReviews = (data.reviews || []).slice(0, 5);
      visibleReviews.forEach((review) => {
        const article = document.createElement('article');
        article.className = 'isun-ritual-reviews__card';
        if (review.id) article.dataset.reviewId = String(review.id);
        const stars = document.createElement('div');
        stars.className = 'isun-ritual-reviews__card-stars';
        stars.setAttribute('aria-label', section.dataset.starsLabel.replace('__rating__', String(review.rating)));
        stars.textContent = '★★★★★'.slice(0, review.rating);
        const meta = document.createElement('p');
        meta.className = 'isun-ritual-reviews__meta';
        const dateValue = review.created_at ? new Date(review.created_at) : null;
        const date = dateValue && !Number.isNaN(dateValue.getTime()) ? dateValue.toLocaleDateString(document.documentElement.lang || undefined, { timeZone: 'UTC', year: 'numeric', month: 'short', day: 'numeric' }) : '';
        meta.textContent = `${review.reviewer_name || section.dataset.customerLabel}${review.verified_buyer ? ` · ${section.dataset.verifiedLabel}` : ''}${date ? ` · ${date}` : ''}`;
        if (review.title) {
          const title = document.createElement('h3');
          title.textContent = review.title;
          article.append(stars, title, meta);
        } else {
          article.append(stars, meta);
        }
        const body = document.createElement('p');
        body.textContent = review.body || '';
        body.style.whiteSpace = 'pre-line';
        const association = document.createElement('p');
        association.className = 'isun-ritual-reviews__association';
        association.textContent = `${section.dataset.productLabel}: ${product.title}`;
        article.append(body, association);
        list.append(article);
      });
      widgetHost.append(list);

      if (Number(data.number_of_reviews) > visibleReviews.length) {
        const allReviews = document.createElement('a');
        allReviews.className = 'isun-ritual-reviews__all button button--secondary';
        allReviews.href = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(product.handle)}#judgeme_product_reviews`;
        allReviews.textContent = section.dataset.viewAllLabel.replace('__count__', String(data.number_of_reviews)).replace('__product__', product.title);
        widgetHost.append(allReviews);
      }
    };

    const render = () => {
      const reviewed = [...products.values()].filter((product) => Number(product.reviewCount) > 0 && product.reviewWidgetData?.reviews?.length);
      if (!reviewed.length) return;
      tabs.replaceChildren();
      reviewed.forEach((product, index) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'isun-ritual-reviews__tab';
        tab.setAttribute('role', 'tab');
        tab.id = `${section.id}-tab-${product.id}`;
        tab.setAttribute('aria-controls', widgetHost.id);
        tab.tabIndex = index === 0 ? 0 : -1;
        tab.setAttribute('aria-selected', String(index === 0));
        tab.dataset.productId = String(product.id);
        tab.textContent = product.title;
        tab.addEventListener('click', () => mountWidget(product));
        tabs.append(tab);
      });
      section.hidden = false;
      mountWidget(reviewed.find((product) => String(product.id) === activeId) || reviewed[0]);
    };

    tabs.addEventListener('keydown', (event) => {
      const allTabs = [...tabs.querySelectorAll('[role="tab"]')];
      const index = allTabs.indexOf(event.target);
      if (index < 0) return;
      let target;
      if (event.key === 'ArrowRight') target = allTabs[(index + 1) % allTabs.length];
      else if (event.key === 'ArrowLeft') target = allTabs[(index + allTabs.length - 1) % allTabs.length];
      else if (event.key === 'Home') target = allTabs[0];
      else if (event.key === 'End') target = allTabs[allTabs.length - 1];
      if (!target) return;
      event.preventDefault();
      target.focus();
      target.click();
    });

    const refresh = async () => {
      const handles = [...new Set([...ritual.querySelectorAll('.bogos-bundle-pp-item[data-product-handle]')]
        .map((item) => item.dataset.productHandle)
        .filter(Boolean))];
      const missing = handles.filter((handle) => !products.has(handle) && !pendingHandles.has(handle));
      if (!missing.length) return;
      missing.forEach((handle) => pendingHandles.add(handle));
      const results = await Promise.all(missing.map((handle) => fetch(productUrl(handle), { credentials: 'same-origin' })
        .then((response) => response.ok ? response.json() : null)
        .then((product) => product ? normalizeReviewData(product) : null)
        .catch(() => null)
        .finally(() => pendingHandles.delete(handle))));
      results.filter(Boolean).forEach((product) => products.set(product.handle, product));
      render();
    };

    const scheduleRefresh = () => {
      if (refreshQueued) return;
      refreshQueued = true;
      requestAnimationFrame(() => { refreshQueued = false; refresh(); });
    };
    scheduleRefresh();
    const observer = new MutationObserver(scheduleRefresh);
    const apps = ritual.querySelector('.isun-ritual__apps');
    if (apps) observer.observe(apps, { childList: true, subtree: true, attributes: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isun-ritual-steps"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const selectBogosProduct = (bogosStep) => {
        const products = [...bogosStep.querySelectorAll('.bogos-bundle-pp-item[data-product-handle]')];
        if (products.length < 2) return products[0] || null;
        return products.find((product) => product.matches('[data-qty]:not([data-qty="0"])'))
          || products.find((product) => !product.hidden && getComputedStyle(product).display !== 'none')
          || products[0];
      };

      const populateRitualSteps = (section) => {
        const builder = document.querySelector('.isun-ritual');
        const bogosSteps = builder ? [...builder.querySelectorAll('.bogos-bundle-pp-step')] : [];
        if (!bogosSteps.length) return false;

        let populatedCount = 0;
        section.querySelectorAll('[data-isun-ritual-step]').forEach((step, index) => {
          const bogosStep = bogosSteps[index];
          const product = bogosStep ? selectBogosProduct(bogosStep) : null;
          if (!product) return;

          const handle = product.dataset.productHandle;
          const sourceName = product.querySelector('.bogos-bundle-pp-item-name');
          const title = sourceName?.title || sourceName?.querySelector('.isun-ritual__product-title-text')?.textContent.trim() || sourceName?.textContent.trim();
          const sourceImage = product.querySelector('.bogos-bundle-pp-item-img');
          const productLink = step.querySelector('[data-isun-step-product]');
          const variantOutput = step.querySelector('[data-isun-step-variant]');
          const selectedVariant = product.querySelector('.bogos-bundle-pp-select-variant-title')?.textContent.trim();

          if (title && productLink) {
            productLink.textContent = title;
            if (handle) productLink.href = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}`;
            productLink.hidden = false;
          }

          if (variantOutput && selectedVariant && selectedVariant.toLowerCase() !== 'default title') {
            variantOutput.textContent = selectedVariant;
            variantOutput.hidden = false;
          }

          const visual = step.querySelector('[data-isun-step-visual].is-product-fallback');
          const existingImage = visual?.querySelector('img');
          if (visual && sourceImage && (!existingImage || visual.dataset.productHandle !== handle)) {
            visual.textContent = '';
            const image = sourceImage.cloneNode(true);
            image.className = 'isun-ritual-step__image is-product';
            image.loading = 'lazy';
            image.alt = title || '';
            if (handle) {
              const imageLink = document.createElement('a');
              imageLink.href = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}`;
              imageLink.setAttribute('aria-label', title || section.dataset.viewProductLabel);
              imageLink.append(image);
              visual.append(imageLink);
            } else {
              visual.append(image);
            }
            visual.dataset.productHandle = handle || '';
          }
          populatedCount += 1;
        });
        return populatedCount > 0;
      };

      document.querySelectorAll('[data-isun-ritual-steps-section]').forEach((section) => {
        populateRitualSteps(section);
        const builderApps = document.querySelector('.isun-ritual__apps');
        if (!builderApps) return;
        const observer = new MutationObserver(() => populateRitualSteps(section));
        observer.observe(builderApps, { attributes: true, childList: true, characterData: true, subtree: true });

        const buyButton = section.querySelector('[data-isun-buy-ritual]');
        const status = section.querySelector('[data-isun-buy-ritual-status]');
        buyButton?.addEventListener('click', () => {
          if (buyButton.disabled) return;
          buyButton.disabled = true;
          buyButton.setAttribute('aria-busy', 'true');
          status.textContent = '';
          document.dispatchEvent(new CustomEvent('isun:ritual:buy-complete', {
            detail: { button: buyButton, status }
          }));
        });
      });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
